<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vii"><span class="txit">Potatoes Not Prozac</span> is</a></p><a id="page_vii">
<p class="ded1">dedicated to the countless people</p>
<p class="ded1">whose fierce desire to heal lead us all</p>
<p class="ded1">to deeper knowledge of a solution</p>
<p class="ded1">that changes lives</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?97a7da82